import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { AngularFireDatabase, AngularFireObject } from 'angularfire2/database';
import { ProfileInfo } from '../models/profile-info';
import { Constants } from '../config/Constants';
import { UtilityService } from './utility.service';
import { AngularFireList } from 'angularfire2/database/interfaces';
import { Observable } from 'rxjs/Observable';
import { ProfileImageUpload } from '../models/profile-image-upload';
import { firebase } from '@firebase/app';
@Injectable()
export class ProfileService {

  basePath:string = "ProfileImages/";

  constructor(private db: AngularFireDatabase,private utilityService:UtilityService) {}

  getUserProfile(): Observable<ProfileInfo>{
    let email = this.utilityService.getUserEmail().replace(/\./g,',');
    let data :AngularFireObject<ProfileInfo> = this.db.object(Constants.PROFILE_URL+'/'+email);
    return  data.valueChanges();
  }

  pushUpload(profileImageUpload: ProfileImageUpload, email:string,profileInfo: ProfileInfo ) {

    let fileExtension = '.' + profileImageUpload.file.name.split('.').pop();
    let fileName = email+fileExtension;
    console.log(email+" "+fileExtension+" "+fileName);

    let storageRef = firebase.storage().ref();
    let uploadTask = storageRef.child(`${this.basePath}/${fileName}`).put(profileImageUpload.file);
    uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED,
      (snapshot) =>  {
        // upload in progress
        profileImageUpload.progress = (uploadTask.snapshot.bytesTransferred / uploadTask.snapshot.totalBytes) * 100
      },
      (error) => {
        // upload failed
        console.log(error)
      },
      () => {
        //upload success
        profileImageUpload.url = uploadTask.snapshot.downloadURL
        profileInfo.profileImageUri = profileImageUpload.url
        profileInfo.updatedAtImage = new Date().getTime();
        profileImageUpload.name = profileImageUpload.file.name;
        //console.log(profileInfo);
        this.updateProfileInfo(profileInfo, email.replace(/\./g,','));
      }
    );
  }

  updateProfileInfo(profileInfo: ProfileInfo, infoEmail):any {
    return this.db.object(Constants.PROFILE_URL+'/'+infoEmail).set(profileInfo);
  }

  deleteFileStorage(url: string, infoEmail, profileInfo: ProfileInfo): any {

    let x = url.split('.').pop();
    let y = x.split('?'); //this will give the file extension from url
    
    let InfoMail = infoEmail.replace(/\,/g,'.')+"."+y[0];
    let storageRef = firebase.storage().ref();
    storageRef.child(`${this.basePath}/${InfoMail}`).delete();
    this.deleteProfileImageData(infoEmail, profileInfo);

  }
  
  deleteProfileImageData(infoEmail, profileInfo: ProfileInfo) {
    profileInfo.profileImageUri = null;
    return this.db.object(Constants.PROFILE_URL+'/'+infoEmail).set(profileInfo);
  }

  setUserProfile(profile :ProfileInfo){
    let email = profile.email.replace(/\./g,',');
    return this.db.object(Constants.PROFILE_URL+'/'+email).set(profile);
  }
  
  setProfileImage(file: File,filename:string):any {
    let storageRef = firebase.storage().ref();
    let extention:string = '.'+file.type.split('/').pop();
    return storageRef.child(`${Constants.PROFILE_IMAGES_BASE_URL}/${filename+extention}`).put(file);
  }

  isUserProfile(emailId: string): any{
    let email = emailId.replace(/\./g,',');
    return firebase.database().ref(Constants.PROFILE_URL+'/'+email).once('value');
  }
}



// WEBPACK FOOTER //
// /workspace/backend-server/src/app/core/services/profile.service.ts